// Code generated by Tortuga protoc-gen-rest-ts. DO NOT EDIT.

/* eslint-disable */
import { ApiError } from "src/core/apiError";
import {
  ReST,
  generateQueryParams,
  generatePayload
} from "src/utils/api/rest/rest";
import { C3LinkRequest } from "src/gen/schema/fred/fapi";
import { UserSessionStartRequest } from "src/gen/schema/fred/fapi";
import { GetUserContextsResponse } from "src/gen/schema/fred/fapi";
import { GetDeviceDetailsResponse } from "src/gen/schema/fred/fapi";
import { EchoResponse } from "src/gen/schema/common/echo";
import { NewOrgRequest } from "src/gen/schema/models/org";
import { UrlResponse } from "src/gen/schema/common/url";
import { C3UserSessionStartRequest } from "src/gen/schema/fred/fapi";
import { EchoRequest } from "src/gen/schema/common/echo";
import { SwitchTenantRequest } from "src/gen/schema/fred/fapi";
import { UserPreferences } from "src/gen/schema/models/user";
import { NewOrgResponse } from "src/gen/schema/models/org";
import { GetTenantInfoRequest } from "src/gen/schema/fred/fapi";
import { AddOrgRequest } from "src/gen/schema/brig/bapi";
import { UserSessionResponse } from "src/gen/schema/models/user";
import { GetDeviceDetailsRequest } from "src/gen/schema/fred/fapi";
import { Tenant } from "src/gen/schema/models/tenant";
import { AddOrgResponse } from "src/gen/schema/brig/bapi";

export const Fred = {
  echo: (
    request: EchoRequest,
    options?: RequestInit | undefined
  ): Promise<EchoResponse> => {
    return ReST.post(
      `/api/v1/hidden/echo/fred`,
      generatePayload(request, EchoRequest),
      options
    ).then((response) => response.json())
      .then(EchoResponse.fromJSON);
  },
  userSessionStart: (
    request: UserSessionStartRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    return ReST.post(
      `/ui/v1/sessions`,
      generatePayload(request, UserSessionStartRequest),
      options
    );
  },
  userSessionStartInTenant: (
    request: UserSessionStartRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: tenantId
    if (!request.tenantId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.tenantId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["tenantId"]
    );
    return ReST.get(
      `/ui/v1/tenants/${request.tenantId}/sessions${queryParams}`,
      options
    );
  },
  inviteAccept: (
    options?: RequestInit | undefined
  ): Promise<Response> => {
    return ReST.get(
      `/ui/v1/invites`,
      options
    );
  },
  userSessionGet: (
    options?: RequestInit | undefined
  ): Promise<UserSessionResponse> => {
    return ReST.get(
      `/ui/v1/sessions`,
      options
    ).then((response) => response.json())
      .then(UserSessionResponse.fromJSON);
  },
  userSessionRefresh: (
    options?: RequestInit | undefined
  ): Promise<Response> => {
    return ReST.put(
      `/ui/v1/sessions`,
      "",
      options
    );
  },
  userSessionEnd: (
    options?: RequestInit | undefined
  ): Promise<Response> => {
    return ReST.post(
      `/ui/v1/sessions/logout`,
      "",
      options
    );
  },
  switchTenant: (
    request: SwitchTenantRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: tenantId
    if (!request.tenantId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.tenantId is invalid.")
      );
    }
    return ReST.post(
      `/ui/v1/tenants/${request.tenantId}/sessions`,
      generatePayload(request, SwitchTenantRequest),
      options
    );
  },
  loginCallback: (
    options?: RequestInit | undefined
  ): Promise<Response> => {
    return ReST.get(
      `/ui/v1/auth/login/callback/okta`,
      options
    );
  },
  logoutCallback: (
    options?: RequestInit | undefined
  ): Promise<Response> => {
    return ReST.get(
      `/ui/v1/auth/logout/callback/okta`,
      options
    );
  },
  getUserContexts: (
    options?: RequestInit | undefined
  ): Promise<GetUserContextsResponse> => {
    return ReST.get(
      `/api/v1/contexts`,
      options
    ).then((response) => response.json())
      .then(GetUserContextsResponse.fromJSON);
  },
  getUserPreferences: (
    options?: RequestInit | undefined
  ): Promise<UserPreferences> => {
    return ReST.get(
      `/api/v1/userPreferences`,
      options
    ).then((response) => response.json())
      .then(UserPreferences.fromJSON);
  },
  getDeviceDetails: (
    request: GetDeviceDetailsRequest,
    options?: RequestInit | undefined
  ): Promise<GetDeviceDetailsResponse> => {
    //Validate Path Param: serialNumber
    if (!request.serialNumber) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.serialNumber is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["serialNumber"]
    );
    return ReST.get(
      `/global/v1/devices/${request.serialNumber}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetDeviceDetailsResponse.fromJSON);
  },
  newOrg: (
    request: NewOrgRequest,
    options?: RequestInit | undefined
  ): Promise<NewOrgResponse> => {
    return ReST.post(
      `/ui/v1/organizations`,
      generatePayload(request, NewOrgRequest),
      options
    ).then((response) => response.json())
      .then(NewOrgResponse.fromJSON);
  },
  getTenantInfo: (
    request: GetTenantInfoRequest,
    options?: RequestInit | undefined
  ): Promise<Tenant> => {
    //Validate Path Param: tenantId
    if (!request.tenantId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.tenantId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["tenantId"]
    );
    return ReST.get(
      `/ui/v1/tenants/${request.tenantId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(Tenant.fromJSON);
  },
  addOrg: (
    request: AddOrgRequest,
    options?: RequestInit | undefined
  ): Promise<AddOrgResponse> => {
    return ReST.post(
      `/api/v1/organizations`,
      generatePayload(request, AddOrgRequest),
      options
    ).then((response) => response.json())
      .then(AddOrgResponse.fromJSON);
  },
  crossGeoOrgCreationStart: (
    request: NewOrgRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    return ReST.post(
      `/ui/v1/geoOrganizations`,
      generatePayload(request, NewOrgRequest),
      options
    );
  },
  crossGeoAddOrgCreationStart: (
    request: AddOrgRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    return ReST.post(
      `/ui/v1/geoUserOrganizations`,
      generatePayload(request, AddOrgRequest),
      options
    );
  },
  getTenantLoginUrl: (
    options?: RequestInit | undefined
  ): Promise<UrlResponse> => {
    return ReST.get(
      `/ui/v1/tenants/loginUrl`,
      options
    ).then((response) => response.json())
      .then(UrlResponse.fromJSON);
  },
  getCuiAdminPortalUrl: (
    options?: RequestInit | undefined
  ): Promise<UrlResponse> => {
    return ReST.get(
      `/ui/v1/cui/adminPortalUrl`,
      options
    ).then((response) => response.json())
      .then(UrlResponse.fromJSON);
  },
  c3Link: (
    request: C3LinkRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/c3/v1/link${queryParams}`,
      options
    );
  },
  c3LinkCallback: (
    options?: RequestInit | undefined
  ): Promise<Response> => {
    return ReST.get(
      `/c3/v1/link/callback`,
      options
    );
  },
  c3UserSessionStart: (
    request: C3UserSessionStartRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/c3/v1/sessions${queryParams}`,
      options
    );
  },
  c3UserSessionEnd: (
    options?: RequestInit | undefined
  ): Promise<Response> => {
    return ReST.post(
      `/c3/v1/sessions/logout`,
      "",
      options
    );
  },
};

